export default function Hero() {
  const handleScroll = (href: string) => {
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/56b243467172c321ea30fde7453831bf.jpg"
          alt="LTF Sourcing — global product sourcing and wholesale supply warehouse facility"
          title="LTF Sourcing global procurement and wholesale supply operations"
          className="w-full h-full object-cover object-top"
          loading="eager"
          fetchPriority="high"
          decoding="async"
        />
        {/* Heavy base overlay for legibility */}
        <div className="absolute inset-0 bg-[#222831] opacity-80"></div>
        {/* Subtle directional gradient on top */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#222831] via-transparent to-[#222831]/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 py-32 flex flex-col items-center text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#C9A227] bg-[#C9A227]/20 mb-8">
          <span className="w-2 h-2 rounded-full bg-[#C9A227] animate-pulse"></span>
          <span className="text-[#C9A227] text-xs font-bold uppercase tracking-widest">
            Product Sourcing · Wholesale Supply · Inventory Solutions
          </span>
        </div>

        {/* Headline */}
        <h1 className="text-5xl lg:text-7xl font-extrabold text-white leading-tight tracking-tight max-w-4xl">
          Global <span className="text-[#C9A227]">Product Sourcing</span>
          <br />
          &amp; Wholesale Supply
          <br />
          <span className="text-[#C9A227]">Done Right.</span>
        </h1>

        {/* Subheadline */}
        <p className="mt-6 text-lg lg:text-xl text-white/90 max-w-2xl leading-relaxed font-light">
          LTF Sourcing connects businesses with <strong className="font-semibold text-white">verified wholesale suppliers</strong>,
          bulk overstock inventory solutions, and end-to-end logistics — cutting <strong className="font-semibold text-white">procurement</strong>
          {" "}costs and complexity from a single trusted partner.
        </p>

        {/* CTA Buttons */}
        <div className="mt-10 flex flex-col sm:flex-row gap-4 items-center">
          <button
            onClick={() => handleScroll("#services")}
            className="px-8 py-4 rounded-full bg-[#C9A227] text-white font-bold text-base hover:bg-[#b08f1e] transition-all cursor-pointer whitespace-nowrap flex items-center gap-2"
          >
            Start Sourcing Now
            <i className="ri-arrow-right-line text-lg"></i>
          </button>
          <button
            onClick={() => handleScroll("#overstock")}
            className="px-8 py-4 rounded-full border-2 border-white text-white font-semibold text-base hover:bg-white hover:text-[#222831] transition-all cursor-pointer whitespace-nowrap flex items-center gap-2"
          >
            <i className="ri-store-2-line text-lg"></i>
            Explore Overstock Deals
          </button>
        </div>

        {/* Stats Row */}
        <div className="mt-20 w-full max-w-3xl">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { value: "50+", label: "Verified Suppliers" },
              { value: "4.8 / 5", label: "Client Rating" },
              { value: "75+", label: "Businesses Served" },
              { value: "8+", label: "Countries Reached" },
            ].map((stat) => (
              <div
                key={stat.label}
                className="flex flex-col items-center bg-white/10 border border-white/20 rounded-2xl py-5 px-3 backdrop-blur-sm"
              >
                <span className="text-3xl font-extrabold text-[#C9A227]">{stat.value}</span>
                <span className="text-sm text-white/85 mt-1.5 text-center leading-snug">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 animate-bounce">
        <span className="text-white/70 text-xs font-medium">Scroll</span>
        <i className="ri-arrow-down-line text-white/70 text-sm"></i>
      </div>
    </section>
  );
}
